// extracted by mini-css-extract-plugin
export default {"wrapper":"Divider_wrapper__hjyX8","vertical":"Divider_vertical__J3u2o"};